const createConsoleArgs = (logject) => {
    const { level, time, context, name, message, errors } = logject;
    const emoji = level.icon ? ` ${level.icon}` : '';
    const prefix = `%c${time} ${level.icon} %c[${level.name.toUpperCase()}] ${name}${emoji}: `;
    const contextInfo = [];
    if (context && context.size) {
        contextInfo.push('\n');
        contextInfo.push(context);
    }
    let args = [prefix]
        .concat(['color: lightgray', 'color: ' + level.color])
        .concat([message])
        .concat(contextInfo);
    if (errors) {
        // @ts-ignore
        args = args.concat(errors);
    }
    return args;
};
export default createConsoleArgs;
//# sourceMappingURL=createConsoleArgs.js.map